module.exports = __webpack_public_path__ + "media/images/slide-3-0253802de759fcd6f372921830e442cf.png";